import getPatientCity from 'utils/print/getPatientCity';

const getInsuranceInsuredsCity = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  return getPatientCity(otherProps);
};

export default getInsuranceInsuredsCity;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsCity.js